import Vue from 'vue';
export const EventBusNotificaciones = new Vue();